import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../constants/path';
import { accountRoutes } from '../../../routes/account';
import { BRAND_NAME, SSO_URL } from '../../../constants';

import modalService from '../../../services/modal';
import { logoutUser } from '../../../services/authentication/logout/actions';

import { mapRoutes } from '../../../utils/routeUtils';
import { isTokenExpired } from '../../../services/authentication/utils';

import AccountNavComponent from './AccountNavComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import {MainContainer} from "./AccountPageStyle";


class AccountPage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);

        if (this.props.location.pathname === PATH.ACCOUNT_PATH) {
            this.props.history.push(PATH.ACCOUNT_JACKPOT_PATH);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);

            if (this.props.location.pathname === PATH.ACCOUNT_PATH) {
                this.props.history.push(PATH.ACCOUNT_JACKPOT_PATH);
            }
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history, location, showModal, logout, MUST_BE_LOGGED_IN }) {
        if (!this.isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                history.push('/');
                resolve();
            }).then(() =>
                logout(() =>
                    showModal(modalService.constants.MODAL_TYPE_LOGIN, {
                        nextPathname: location.pathname,
                        dynamicText: format(MUST_BE_LOGGED_IN, BRAND_NAME),
                        redirectUrl: SSO_URL
                    })
                )
            );
        }
    }

    componentDidMount() {
        // Here load global account infos if needed
    }

    render() {
        if (this.isMemberAuthenticated()) {
            return (
                <MainContainer className="conteneur conteneur-mobile" id="p-compte">
                    <LocalizedBreadcrumbItem to={PATH.ACCOUNT_PATH} disabled>
                        {this.props.BREADCRUMB}
                    </LocalizedBreadcrumbItem>
                    <h1>{this.props.TITLE}</h1>
                    <AccountNavComponent />
                    <div className="account-content">{mapRoutes(accountRoutes)}</div>
                </MainContainer>
            );
        }
        return null;
    }
}

AccountPage.propTypes = {
    token: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        MUST_BE_LOGGED_IN: state.i18n.page.login.MUST_BE_LOGGED_IN,
        BREADCRUMB: state.i18n.page.ACCOUNT.BREADCRUMB,
        TITLE: state.i18n.page.ACCOUNT.TITLE
    };
};
const mapDispatchToProps = {
    showModal: modalService.actions.showModal,
    logout: logoutUser
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(AccountPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountPage.js